<template>
	<div class="ctime_top">
		<ul class="clearfix">
			<li v-for="(item, index) in c_timelist" class="pull-left item-time">
				<div class="ct">
					<h3>{{item.zh}}</h3>
					<h4>{{item.day}}</h4>
				</div>
				<div class="ctime_main clearfix">
					<label v-for="(c_item, i2) in item.slot" @click="slot_click(item.sign, item.teacherid, index, i2, c_item)" :class="{radio_on: radio_check1==c_item.id , over: c_item.state == 1}" :disabled="c_item.state == 1">
						<input type="radio" name="radio1" :value="c_item.id" v-model="radio_check1" :disabled="c_item.state == 1" />
						<span v-if="c_item.state ==0">{{c_item.start}}<br/>-<br/>{{c_item.end}}</span><span v-else>已预约</span>
					</label>
				</div>
			</li>
		</ul>
		<!-- 尾部 -->
		<div class="qr_code text-center">
			<p>如本周预约时间已满，需要预约其他时间</p>
			<p>请添加客服微信：Ella_NEDP</p>
			<img src="@a/customer_service.jpg" alt="" />
			<div>
				<a @click="submitData" :class="[isSelect ? 'active' : '', 'sub_btn']">提交</a>
			</div>
		</div>
		<!-- 时间已被选择 -->
		<van-popup class="radius" :close-on-click-overlay="true" v-model="pop_show3">
			<div class="pop pop-pa pop-task">
				<div class="close_bg clearfix">
					<img @click="pop_show3 = false" class="pull-right" src="@a/close.png" alt="" />
				</div>
				<div>
					<img src="@a/erro.png" alt="" />
				</div>
				<h2>非常抱歉</h2>
				<p class="text-center">该时间段已被选择，请重新选择！</p>
				<a class="btns text-center" @click="pop_show3 = false">重新选择</a>
			</div>
		</van-popup>
		<!-- 信息提示 -->
		<van-popup class="radius" :close-on-click-overlay="true" v-model="pop_show2">
			<div class="pop pop-pa">
				<div class="close_bg clearfix">
					<router-link to="/totoring_buy_success">
						<img class="pull-right" src="@a/close.png" alt="" />
					</router-link>
				</div>
				<h2>您的生涯辅导已经预约成功<br/>咨询师已经收到您的预约信息</h2>
				<p>1、  我们会在辅导前 30 分钟通过新精英人才加速器微信服务号推送提示信息<br/>2、  请务必准时查阅辅导须知，到时您可以看到辅导知情同意书、您目标职位的相关信息以及辅导前要思考的问题。<br/>3、  辅导将通过微信平台进行，请找一个安静不被打扰且网络信号稳定的环境，咨询师的微信将在辅导须知一并告知。</p>
				<router-link class="btns text-center" to="/totoring_buy_success">我已知晓</router-link>
			</div>
		</van-popup>
		<!-- 春节放假 -->
		<van-popup class="radius" :close-on-click-overlay="true" v-model="pop_show">
			<div class="pop">
				<img src="@a/fd_cj.png" />
			</div>
		</van-popup>
	</div>
</template>
<script>
	import { teachertimelist, subteachertime } from '@/api/totoring'
	import { queryString } from '@/utils/tools'
	import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {
				pop_show: false,
				pop_show2: false,
				pop_show3: false,
				//
				radio_check1: null,
				show_body: false,
				c_timelist: [],
				teacherid: null,
				isSelect: false,
				sign: null,
				state: false
			}
		},
		methods: {
			slot_click(sign, teacherid, rowIndex, itemIndex, item){
				this.isSelect = true;
				this.radio_check1 = item.id;
				this.sign = sign;
				this.teacherid = teacherid;
			},
			submitData(){
				if(!this.isSelect){
					return
				}
				//
				subteachertime({
					teacherid: this.teacherid,
					id: this.radio_check1,
					date_on: this.sign
				})
				.then((data) => {
					if(data.code){
						// 已选
						this.pop_show3 = true;
					}else{
						// 成功
						this.pop_show2 = true;
					}
				})
			},
			pullData(){
				let q = this.$route.query;
				teachertimelist({
					teacherid: q.teacherid
				})
				.then((data) => {
					shareCon("totoring",this);
					if(typeof data === 'string'){
						this.$router.push({
							path: '/totoring_buy_success',
							query: {
								pay: queryString(data, 'pay')
							}
						})
					}else{
						this.c_timelist = data.list;
						this.state = data.state;
					}
				})
			}
		},
		created(){
			this.pullData();
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/remChange.scss";
	.ctime_top{
		padding: changeRem(1.2)+px changeRem(0.5)+px changeRem(5.82)+px;
		background: #fff;
	}
	.item-time{
    width: changeRem(1.8)+px;
    text-align: center;
    float: left;
    margin-right: changeRem(0.2)+px;
    .ct{
    	h3{
		    font-size: changeRem(0.56)+px;
		    color: #333;
		    line-height: changeRem(1.4)+px;
	    }
	    h4{
  	    font-size: changeRem(0.52)+px;
		    color: #999;
		    line-height: changeRem(0.5)+px;
	    }
    }
	}
	.ctime_main{
		font-size: 16px;
		label{
	    width: changeRem(1.8)+px;
	    height: changeRem(2.52)+px;
	    border: 2px solid rgba(204, 204, 204, 1);
	    border-radius: changeRem(0.16)+px;
	    position: relative;
	    padding: 0;
	    line-height: changeRem(0.6)+px;
	    text-align: center;
	    color: #ccc;
	    font-size: changeRem(0.52)+px;
	    float: left;
	    margin-top: changeRem(0.8)+px;
	    padding-top: changeRem(0.4)+px;
		}
		label.over {
	    border: none;
	    background: #ccc;
	    color: #fff;
	    line-height: changeRem(2.52)+px;
	    padding-top: 0;
		}
		input[type=radio]{
	    position: absolute;
	    border: 0;
	    outline: 0!important;
	    background-color: transparent;
	    -webkit-appearance: none;
	    width: changeRem(1.8)+px;
	    height: changeRem(2.52)+px;
	    display: inline-block;
	    right: 0;
	    top: 0;
		}
		label.radio_on{
	    background-color: #EB5032;
	    border-color: #EB5032;
	    color: #fff;
		}
	}
	.radius{
		border-radius: 15px;
	}
	.pop{
		width: 8rem;
		img{
			max-width: 100%;
		}
	}
	.pop-pa{
		padding: changeRem(0.6)+px changeRem(0.6)+px 80px;
		.close_bg{
			img{
				width: changeRem(0.64)+px;
			}
		}
		h2{
			text-align: center;
	    font-size: changeRem(0.72)+px;
    	color: #333;
    	font-weight: bold;
    	line-height: changeRem(0.84)+px;
    	margin-top: changeRem(0.5)+px;
		}
		p{
	    font-size: changeRem(0.56)+px;
  		color: #666;
  		width: changeRem(9.88)+px;
	    margin: 0 auto;
	    line-height: changeRem(0.84)+px;
	    margin-top: changeRem(0.6)+px;
	    text-align: justify;
		}
		.btns{
	    display: block;
	    margin: 0 auto;
	    margin-top: changeRem(1.4)+px;
	    width: changeRem(7.7)+px;
	    height: changeRem(1.6)+px;
	    line-height: changeRem(1.6)+px;
	    background: rgba(235, 80, 50, 1);
	    border-radius: changeRem(0.16)+px;
	    color: #fff;
	    font-size: changeRem(0.68)+px;
		}
	}
	.pop-task{
		h2{
	    font-size: changeRem(0.72)+px;
	    color: #333;
	    margin-top: changeRem(1.5)+px;
	    font-weight: bold;
		}
		p{
	    font-size: changeRem(0.56)+px;
	    color: #666;
	    margin-top: changeRem(0.92)+px;
		}
	}
	.qr_code{
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		padding: 20px 0;
		background: #f0f0f0;
		img{
			height: changeRem(4)+px;
	    width: changeRem(4)+px;
	    margin-top: changeRem(0.4)+px;
		}
		.sub_btn{
			display: block;
			width: changeRem(3.48)+px;
	    height: changeRem(1.32)+px;
	    line-height: changeRem(1.32)+px;
	    background: rgba(204, 204, 204, 1);
	    border-radius: changeRem(0.66)+px;
	    margin: 0 auto;
	    margin-top: changeRem(2.76)+px;
	    color: #fff;
	    font-size: changeRem(0.68)+px;
	    text-align: center;
	    margin-top: changeRem(0.5)+px;
		}
		.active{
	    background-color: #EB5032;
		}
	}
</style>